import React from "react";

const BrandLogo = ({ className = "" }) => {
  // Determine if we are on a light background (Navbar/Splash) or dark (Footer/Legacy Auth)
  const isNavbar = className.includes("district-navbar-logo");
  const isFooter = className.includes("district-footer-logo");
  
  // The user explicitly requested #0D141C for the logo color.
  // This filter approximates #0D141C from a black source.
  const brandColorFilter = "brightness(0) saturate(100%) invert(8%) sepia(21%) saturate(1011%) hue-rotate(171deg) brightness(91%) contrast(96%)";
  
  // If in Footer or other dark areas, use white. Otherwise use the brand color #0D141C.
  const filterStyle = (isFooter) ? "invert(1)" : brandColorFilter;

  return (
    <>
      <style>
        {`
          .brand-logo-professional {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            overflow: visible;
          }
          
          .brand-logo-animated {
            animation: districtEntrance 2s cubic-bezier(0.23, 1, 0.32, 1) both;
          }
          
          .district-logo {
            height: 42px;
            width: auto;
            display: block;
            filter: var(--logo-filter);
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          }

          .brand-logo-professional:hover .district-logo {
            transform: scale(1.08) rotate(-1.5deg);
            filter: var(--logo-filter) drop-shadow(0 4px 12px rgba(13, 20, 28, 0.15));
          }
          
          @keyframes districtEntrance {
            0% {
              opacity: 0;
              transform: translateY(24px) scale(0.85);
              filter: blur(12px) var(--logo-filter);
            }
            100% {
              opacity: 1;
              transform: translateY(0) scale(1);
              filter: blur(0) var(--logo-filter);
            }
          }

          @media (max-width: 768px) {
            .district-logo {
              height: 32px;
            }
          }
        `}
      </style>
      <div 
        className={`brand-logo-professional brand-logo-animated ${className}`}
        style={{ '--logo-filter': filterStyle }}
      >
        <img
          src="https://b.zmtcdn.com/data/edition_assets/17466982242413.svg"
          alt="District"
          className="district-logo"
        />
      </div>
    </>
  );
};

export default BrandLogo;
